// Storefront URL previews in the catalog (the link field and the search-result preview). URL paths are
// data, never translated, so they are built here rather than written as JSX text (D-013 string layer).

export type StoreSection = "products" | "brands" | "categories" | "collections";

/** `/brands/red-shoes`: the page's path on the storefront ("…" until there is a slug). */
export const storePath = (section: StoreSection, slug: string | null | undefined): string =>
  `/${section}/${slug || "…"}`;

/** `shop.adyvance.com › brands › red-shoes`: the breadcrumb a search result shows. */
export const searchCrumb = (
  host: string | null | undefined,
  section: StoreSection,
  path: string | null | undefined,
): string => [host || "…", section, ...(path ? path.split("/") : ["…"])].join(" › ");
